import { render } from "./Capacity.vue?vue&type=template&id=32d52988"
import script from "./Capacity.vue?vue&type=script&lang=js"
export * from "./Capacity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__